import { useTranslation } from "react-i18next";

import { ReactComponent as DashboardIcon } from "assets/icons/menu/dashboard.svg";
import { ReactComponent as TasksIcon } from "assets/icons/menu/tasks.svg";
import ClientsIcon from "assets/icons/menu/clients.svg";
import WebmastersIcon from "assets/icons/menu/webmasters.svg";
import UsersIcon from "assets/icons/menu/users.svg";
import { ReactComponent as ReferralProgramIcon } from "assets/icons/menu/referral-program.svg";
import { ReactComponent as NotificationIcon } from "assets/icons/menu/notification.svg";
import { ReactComponent as SettingsIcon } from "assets/icons/menu/settings.svg";

const AdminMenu = (unreaded_count) => {
  const { t } = useTranslation();

  const menu_items = [
    {
      icon: <DashboardIcon />,
      label: t("Dashboard"),
      href: "/",
    },
    {
      icon: <TasksIcon />,
      label: t("Tasks"),
      href: "/tasks",
    },
    {
      icon: ClientsIcon,
      label: t("Clients"),
      href: "/clients",
    },
    {
      icon: WebmastersIcon,
      label: t("Webmasters"),
      href: "/webmasters",
    },
    {
      icon: UsersIcon,
      label: t("Users"),
      href: "/users",
    },
    {
      icon: <ReferralProgramIcon />,
      label: t("Referral program"),
      href: "/referral-program",
    },
    {
      icon: <NotificationIcon />,
      label: t("Notifications"),
      href: "/notifications",
      count: unreaded_count,
    },
    {
      icon: <SettingsIcon />,
      label: t("Settings"),
      href: "/settings",
    },
  ];

  return menu_items;
};

export default AdminMenu;
